package it.neckar.lizergy.model.company

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@SerialName("QuoteCompanyInformation")
@Serializable
data class QuoteCompanyInformation(
  override val companyProfile: CompanyProfile,
  override val name: String,
  override val address: it.neckar.lizergy.model.customer.Address,
  override val contactInformation: ContactInformation,
  override val bankInformation: PvBankInformation,
  override val legalInformation: CompanyLegalInformation,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : CompanyInformation {

  val companyCode: CompanyCode
    get() = companyProfile.companyCode

  companion object {
    val testCompany: QuoteCompanyInformation = QuoteCompanyInformation(
      companyProfile = TestCompanyProfile(CompanyCode.TestCompany),
      name = "Test GmbH",
      address = it.neckar.lizergy.model.customer.Address("Teststraße", "99", "77777", "Test-Stadt"),
      contactInformation = ContactInformation("lizergy-test@neckar-it.de", "+49 (0) 7473 / 959496-0", "+49 (0) 7473 / 959496-99", "lizergy-test.neckar.it"),
      bankInformation = PvBankInformation(
        name = "VR Bank Steinlach-Wiesaz-Härten",
        iban = "DE 40 5555 6666 7777 8888 99",
        bic = "GENODES1STW",
      ),
      legalInformation = CompanyLegalInformation("Martha Testfrau", "Amtsgericht Stuttgart", "DE 192736450", "HRB 112233"),
    )
  }
}
